import React, {Component} from 'react';
import PlayStore from "asset/img/playstore.png";
export default class Footer extends Component {
    render() {
        return (
            <section className="main-footer">
                <div className="container">
                    <div className="col-12">
                        <a
                            href="https://play.google.com/store/apps/details?id=org.lakshyasolutions.pocketlab"
                            target="_blank">
                            <img src={PlayStore} className="playstore-icon"/></a>
                        <p>
                            © Copyright 2018 Lakshya Pocket Lab - All Rights Reserved
                        </p>
                    </div>
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Footer.jsx